/* eslint-disable @typescript-eslint/no-explicit-any */
import { AuthApiService } from '@revenuewell/logic-http';
import { OidcService } from '@revenuewell/logic-oidc';
import { NavigationService } from '@revenuewell/logic-navigation';

export class CrossAppService extends AuthApiService {
    private config: any;

    constructor(config: any, 
        oidcService: OidcService, 
        navigationService: NavigationService) {
        super(oidcService, navigationService);
        this.config = config;
    }

    public createCrossAppV1Url = async (redirectUrl: string) => {
        const accessToken = await this.oidcService.getAccessToken();
        const url = `${this.config.crossApp.apiUrl}/api/CrossAppUrlV1`
            + `?accessToken=${accessToken}&redirectUrl=${encodeURIComponent(redirectUrl)}`;
        const response = await this.authFetch(url, { method: 'POST' });
        return response.text();
    }

    public createCrossAppV2Url = async (applicationUrl: string) => {
        const accessToken = await this.oidcService.getAccessToken();
        const url = `${this.config.crossApp.apiUrl}/api/CrossAppUrlV2`
            + `?accessToken=${accessToken}&applicationUrl=${encodeURIComponent(applicationUrl)}`;
        const response = await this.authFetch(url, { method: 'POST' });
        return response.text();
    }
}